/*
 * @Author: wangyinhu wangyinhude@163.com
 * @Date: 2023-08-23 10:52:34
 * @LastEditors: wangyinhu wangyinhude@163.com
 * @LastEditTime: 2025-07-16 10:49:47
 * @FilePath: \汇学堂Saas- 企业中心pc\hxt-saas-pc\src\config.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
let baseUrl;
let openUrl;
let publicPath;
//console.log(process.env.VUE_APP_CURRENTMODE);
if (process.env.VUE_APP_CURRENTMODE === "development") {
  // baseUrl = "http://saas-dev.taxchina.com";
  // openUrl = "http://saas-dev.taxchina.com";
  baseUrl = "https://saas-test.taxchina.com";
  openUrl = "https://saas-test.taxchina.com";
  publicPath = "https://g1.saas-dev.taxchina.com/";


} else if (process.env.VUE_APP_CURRENTMODE === "test") {
  baseUrl = "https://saas-test.taxchina.com";
  openUrl = "https://saas-test.taxchina.com";
  publicPath = "https://g1.saas-test.taxchina.com/";
} else if (process.env.VUE_APP_CURRENTMODE === "production") {
  baseUrl = "https://saas.taxchina.com";
  openUrl = "https://saas.taxchina.com";
  publicPath = "https://g1.saas.taxchina.com/";
}
export default {
  systemname: "",
  baseUrl: baseUrl,
  openUrl: openUrl,
  publicPath: publicPath,
};
